import { createAction } from '@reduxjs/toolkit';
import { SpacePermissionCheckerParams } from '../types';

export const editProfile =
  createAction<SpacePermissionCheckerParams>('EDIT_PROFILE');
